export const percentage = 1;
export const range = 2;
export const miligram = 3;
export const ratio = 4;
